export enum GLOBAL_MODAL {
  SESSION_EXPIRING = 'SESSION_EXPIRING',
}
